import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import { CreditCard } from './CreditCard';
export const Hero = () => {
  const scrollToForm = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-be-navy pt-12 pb-20 px-4 relative overflow-hidden" data-id="element-98">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-be-pink/10 rounded-full blur-[100px] pointer-events-none" data-id="element-99"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-100">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-white/80 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-4" data-id="element-101">
          You've had us bookmarked.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.1,
        duration: 0.5
      }} className="mb-12 flex flex-col items-center" data-id="element-102">
          <h2 className="text-be-pink text-glow-pink font-display text-4xl sm:text-5xl md:text-6xl tracking-wide mb-[-10px]" data-id="element-103">
            THIS WEEK ONLY:
          </h2>
          <h1 className="text-be-pink text-glow-pink font-display text-7xl sm:text-8xl md:text-[120px] leading-none tracking-wider" data-id="element-104">
            FIRST-VISIT
            <br data-id="element-105" />
            RESET
          </h1>
        </motion.div>

        {/* Visual Cluster */}
        <div className="relative w-full max-w-3xl h-[450px] sm:h-[500px] mb-16 mx-auto flex justify-center items-center" data-id="element-106">
          {/* Provider Polaroid */}
          <motion.div initial={{
          opacity: 0,
          x: -50,
          rotate: -10
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: -6
        }} transition={{
          delay: 0.3,
          type: 'spring'
        }} className="absolute left-4 sm:left-12 z-20 bg-white p-3 pb-10 rounded-lg shadow-2xl w-[220px] sm:w-[280px]" data-id="element-107">
            <div className="w-full aspect-[4/5] bg-gray-200 rounded overflow-hidden" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/tvo7tq2ztRiDXEJ3ru9fxy/2.png" alt="Be Clinical Provider" className="w-full h-full object-cover" data-id="element-109" />
            </div>
          </motion.div>

          {/* Consult Note */}
          <motion.div initial={{
          opacity: 0,
          y: -30,
          rotate: 10
        }} animate={{
          opacity: 1,
          y: 0,
          rotate: 6
        }} transition={{
          delay: 0.4,
          type: 'spring'
        }} className="absolute top-0 right-12 sm:right-32 z-10 bg-[#FFF9F9] px-6 py-8 rounded-xl shadow-lg w-[240px] sm:w-[280px] text-center" data-id="element-110">
            <p className="text-be-pink text-xs font-bold tracking-[0.2em] uppercase mb-2 border-b border-be-pink/30 pb-2 inline-block" data-id="element-111">
              From us, with care
            </p>
            <p className="font-script text-be-pink text-3xl sm:text-4xl leading-tight mt-2" data-id="element-112">
              Complimentary
              <br data-id="element-113" />
              Consult
            </p>
          </motion.div>

          {/* $150 Credit Card */}
          <motion.div initial={{
          opacity: 0,
          x: 50,
          rotate: -5
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: -12
        }} transition={{
          delay: 0.5,
          type: 'spring'
        }} className="absolute bottom-4 right-4 sm:right-12 z-30" data-id="element-114">
            <CreditCard className="scale-75 sm:scale-100 origin-bottom-right shadow-2xl shadow-be-pink/20" data-id="element-115" />
          </motion.div>
        </div>

        {/* Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center px-4" data-id="element-116">
          <p className="text-xl sm:text-2xl md:text-3xl font-bold leading-snug mb-6 uppercase" data-id="element-117">
            Book a complimentary skin consultation this week and we'll add a{' '}
            <span className="text-be-pink text-glow-pink" data-id="element-118">$150 credit</span>{' '}
            toward your first treatment of the year.
          </p>
          <p className="text-white/80 text-sm sm:text-base md:text-lg mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-119">
            No pressure. No commitment beyond showing up. Our team maps out what
            your skin actually needs, then the credit is yours to use on any
            treatment you book from that visit.
          </p>

          <p className="text-be-pink font-bold tracking-[0.2em] text-xs sm:text-sm uppercase mb-6" data-id="element-120">
            Offer expires Sunday at midnight
          </p>

          <button onClick={scrollToForm} className="bg-white text-be-navy hover:bg-gray-100 transition-colors rounded-full py-4 px-8 sm:px-12 font-bold tracking-[0.1em] uppercase flex items-center justify-center gap-3 mx-auto shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_40px_rgba(255,255,255,0.5)]" data-id="element-121">
            <Calendar size={20} className="text-be-pink" data-id="element-122" />
            Book Your Consultation
          </button>
        </motion.div>
      </div>
    </section>;
};